let createStore = null;
if (process.env.NODE_ENV === 'development') {
  createStore = require('./store.development.js').default;
} else {  
  createStore = require('./store.production.js').default;
}

export default createStore;
